export default "__VITE_ASSET__DiiSLegk__"